// src/pages/feed/FeedExplorePage.tsx
import React from "react";
import SocialLayout from "./SocialLayout";
import FeedExplore from "./components/FeedExplore";

const FeedExplorePage: React.FC = () => {
  return (
    <SocialLayout title="Explorar Feed">
      <h1 className="h4 fw-bold mb-4">Explorar Feed</h1>
      <FeedExplore />
    </SocialLayout>
  );
};

export default FeedExplorePage;
